module.exports = __webpack_public_path__ + "img/1_silver.0e5c3f4b.svg";